import { z } from 'zod';
const uuid = z.uuid().refine((value) => value !== '00000000-0000-0000-0000-000000000000');
const generation = z.number().int().min(1).max(0xffff_ffff);
const label = (bytes) => z
    .string()
    .min(1)
    .max(bytes)
    .refine((value) => value.trim() === value &&
    new TextEncoder().encode(value).length <= bytes &&
    ![...value].some((char) => char.charCodeAt(0) < 32 || (char.charCodeAt(0) >= 127 && char.charCodeAt(0) <= 159)));
const actionId = z.string().regex(/^[a-zA-Z0-9][a-zA-Z0-9_-]{0,63}$/);
export const linuxActionSchema = z
    .object({
    id: actionId,
    unit: z.string().regex(/^[a-zA-Z0-9][a-zA-Z0-9_.-]{0,119}\.service$/),
    operation: z.enum(['reload', 'restart']),
    timeout_ms: z.number().int().min(100).max(10_000),
    break_glass: z.boolean(),
})
    .strict()
    .refine((action) => action.operation !== 'restart' || action.break_glass);
// Key order is the Rust Policy serialization order. Cross-language digest fixtures protect it.
export const linuxPolicySchema = z
    .object({
    version: z.literal(1),
    id: uuid,
    revision: generation,
    device_id: uuid,
    owner_uid: z.number().int().min(1).max(0xffff_fffe),
    issuer: label(512).refine((value) => {
        try {
            const u = new URL(value);
            return u.protocol === 'https:' && !u.username && !u.password && !u.search && !u.hash;
        }
        catch {
            return false;
        }
    }),
    actions: z.array(linuxActionSchema).max(32),
})
    .strict()
    .refine(({ actions }) => new Set(actions.map((a) => a.id)).size === actions.length &&
    new Set(actions.map((a) => `${a.unit}:${a.operation}`)).size === actions.length);
export const linuxRequestSchema = z
    .object({ id: uuid, action_id: actionId, reason: label(512) })
    .strict();
export const actionApprovalBindingSchema = z
    .object({
    version: z.literal(1),
    requestId: uuid,
    controlRequestId: uuid,
    authorizationKind: z.enum(['operation', 'break_glass']),
    deviceId: uuid,
    connectionId: uuid,
    sessionId: uuid,
    sessionGeneration: generation,
    grantId: uuid,
    grantGeneration: generation,
    localUid: z.number().int().min(1).max(0xffff_fffe),
    actionId,
    operation: z.enum(['service.reload', 'service.restart']),
    service: z.string().regex(/^[a-zA-Z0-9][a-zA-Z0-9_.-]{0,119}\.service$/),
    policyId: uuid,
    policyRevision: generation,
    policyDigest: z.string().regex(/^[a-f0-9]{64}$/),
    reason: label(512),
    requesterId: label(128),
})
    .strict();
export const linuxEventSchema = z.discriminatedUnion('operation', [
    z.object({ operation: z.literal('catalog') }).strict(),
    z.object({ operation: z.literal('prepare'), request: linuxRequestSchema }).strict(),
    z.object({ operation: z.literal('status'), id: uuid }).strict(),
    z.object({ operation: z.literal('execute'), id: uuid }).strict(),
    z.object({ operation: z.literal('cancel'), id: uuid }).strict(),
]);
//# sourceMappingURL=linux-delegation.js.map